import PassIncomplete from "./pass-incomplete";
import PassResultType from "../enums/pass-result-type";

export default class PassDropped extends PassIncomplete {
    constructor(intendedFor, brokenUpBy) {
        super(intendedFor, brokenUpBy);

        this.passResultCode = PassResultType.DROPPED.code;
    }
}
